import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import TwoFAVerificationPage from "./pages/TwoFAVerificationPage";
import "./styles/Variable.css";
import ForgotPassword from "./pages/ForgotPassword";
import EmailVerify from "./pages/EmailVerify";
import CreatePassword from "./pages/CreatePassword";
import ManageMember from "./pages/ManageMember";
import Require2FA from "./components/Require2FA";
import RequireAuth from "./components/RequireAuth";
import { EmailVerifyGuard, CreatePasswordGuard } from "./components/RouteGuard";
import { useAutoLogout } from "./hooks/useAutoLogout";
import { useTabClose } from "./hooks/useTabClose";
import ManageCustomer from "./pages/ManageCustomer";
import MemberDetails from "./pages/MemberDetails";
import CustomerDetails from "./pages/CustomerDetails";
import CustomerCashRequestHistory from "./pages/CustomerCashRequestHistory";
import CustomerWalletPage from "./pages/CustomerWalletPage";
import EditCustomerProfile from "./pages/EditCustomerProfile";
import CreateCustomerAccount from "./pages/CreateCustomerAccount";
import CreateMemberAccount from "./pages/CreateMemberAccount";
import MemberWalletPage from "./pages/MemberWalletPage";
import MemberCashRequestHistory from "./pages/MemberCashRequestHistory";
import CustomerUnitsTransactionHistory from "./pages/CustomerUnitsTransactionHistory";
import CustomerSalesHistory from "./pages/CustomerSalesHistory";
import EditMemberProfile from "./pages/EditMemberProfile";
import MemberUnitsTransactionHistory from "./pages/MemberUnitsTransactionHistory";
import ManageAgent from "./pages/ManageAgent";
import CreateAgentAccount from "./pages/CreateAgentAccount";
import AgentDetails from "./pages/AgentDetails";
import EditAgentProfile from "./pages/EditAgentProfile";
import AgentWalletPage from "./pages/AgentWalletPage";
import AgentUnitsTransactionHistory from "./pages/AgentUnitsTransactionHistory";
import AgentCashRequestHistory from "./pages/AgentCashRequestHistory";
import ManageRetailerShop from "./pages/ManageRetailerShop";
import RetailShopDetails from "./pages/RetailShopDetails";
import RetailerWalletPage from "./pages/RetailerWalletPage";
import RetailerUnitsTransactionHistory from "./pages/RetailerUnitsTransactionHistory";
import RetailCashRequestHistory from "./pages/RetailCashRequestHistory";
import EditRetailerProfile from "./pages/EditRetailerProfile";
import CreateRetailerAccount from "./pages/CreateRetailerAccount";
import Dashboard from "./pages/Dashboard";
import ManageAdvertisingAgent from "./pages/ManageAdvertisingAgent";
import AdvertisingAgentApprovedHistory from "./pages/AdvertisingAgentApprovedHistory";
import AdvertisingAgentRejectedHistory from "./pages/AdvetisingAgentRejectedHistory";
import AdvertisingAgentDetails from "./pages/AdvertisingAgentDetails";
import AdvertisingAgentWallet from "./pages/AdvertisingAgentWallet";
import InvitationHistory from "./pages/InvitationHistory";
import AdvertisingAgentTransaction from "./pages/AdvertisingAgentTransaction";
import RequestDetails from "./pages/RequestDetails";
import AdvertisingAgentTransactionHistory from "./pages/AdvertisingAgentTransactionHistory";
import AdvertisingAgentEdit from "./pages/AdvertisingAgentEdit";
import ManageBusinessAgent from "./pages/ManageBusinessAgent";
import BusinessAgentDetails from "./pages/BusinessAgentDetails";
import BusinessAgentWallet from "./pages/BusinessAgentWallet";
import BusinessAgentTransaction from "./pages/BusinessAgentTransaction";
import BusinessAgentRequestDetails from "./pages/BusinessAgentRequestDetails";
import BusinessAgentTransactionHistory from "./pages/BusinessAgentTransactionHistory";
import BusinessAgentEdit from "./pages/BusinessAgentEdit";
import BusinessAgentInvitationHistory from "./pages/BusinessAgentInvitationHistory";
import BusinessAgentApprovedHistory from "./pages/BusinessAgentApprovedHistory";
import BusinessAgentRejectedHistory from "./pages/BusinessAgentRejectedHistory";
import AgentInvitationHistory from "./pages/AgentInvitationHistory";
import AgentRequestDetails from "./pages/AgentRequestDetails";
import ManageSuppliers from "./pages/ManageSupplier";
import CreateSupplierAccount from "./pages/CreateSupplierAccount";
import SupplierDetails from "./pages/SupplierDetails";
import SupplierWallet from "./pages/SupplierWallet";
import EditSupplierProfile from "./pages/EditSupplierProfile";
import ManageCategory from "./pages/ManageCategory";
import CategoryDetails from "./pages/CategoryDetails";
import ManageSubCategories from "./pages/ManageSubCategories";
import SubCategoryDetails from "./pages/SubCategoryDetails";
import CreateCategory from "./pages/CreateCategory";
import CreateSubCategory from "./pages/CreateSubCategory";
import EditCategory from "./pages/EditCategory";
import EditSubCategory from "./pages/EditSubCategory";
import ManageProduct from "./pages/ManageProduct";
import CreateProduct from "./pages/CreateProduct";
import ProductDetails from "./pages/ProductDetails";
import EditProduct from "./pages/EditProduct";
import ManagePromotion from "./pages/ManagePromotion";
import PromotionDetails from "./pages/PromotionDetails";
import CreatePromotion from "./pages/CreatePromotion";
import EditPromotion from "./pages/EditPromotion";
import ManageParentsConsent from "./pages/ManageParentsConsent";
import ParentsConsentDetails from "./pages/ParentsConsentDetails";
import EditParentsConsent from "./pages/EditParentsConsent";

function AppContent() {
  useAutoLogout(5);
  useTabClose();

  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/2fa"
        element={
          <Require2FA>
            <TwoFAVerificationPage />
          </Require2FA>
        }
      />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/email-verify"
        element={
          <EmailVerifyGuard>
            <EmailVerify />
          </EmailVerifyGuard>
        }
      />
      <Route
        path="/create-password"
        element={
          <CreatePasswordGuard>
            <CreatePassword />
          </CreatePasswordGuard>
        }
      />
      <Route
        path="/manage-member"
        element={
          <RequireAuth>
            <ManageMember />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-customer"
        element={
          <RequireAuth>
            <ManageCustomer />
          </RequireAuth>
        }
      />
      <Route
        path="/member-details"
        element={
          <RequireAuth>
            <MemberDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/customer-details"
        element={
          <RequireAuth>
            <CustomerDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/customer-wallet-details"
        element={
          <RequireAuth>
            <CustomerWalletPage />
          </RequireAuth>
        }
      />
      <Route
        path="/customer-cash-request-history"
        element={
          <RequireAuth>
            <CustomerCashRequestHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/edit-customer-profile"
        element={
          <RequireAuth>
            <EditCustomerProfile />
          </RequireAuth>
        }
      />
      <Route
        path="/create-customer-account"
        element={
          <RequireAuth>
            <CreateCustomerAccount />
          </RequireAuth>
        }
      />
      <Route
        path="/create-member-account"
        element={
          <RequireAuth>
            <CreateMemberAccount />
          </RequireAuth>
        }
      />
      <Route
        path="/member-wallet-details"
        element={
          <RequireAuth>
            <MemberWalletPage />
          </RequireAuth>
        }
      />
      <Route
        path="/member-cash-request-history"
        element={
          <RequireAuth>
            <MemberCashRequestHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/customer-units-transaction-history"
        element={
          <RequireAuth>
            <CustomerUnitsTransactionHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/customer-sales-history"
        element={
          <RequireAuth>
            <CustomerSalesHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/retail-sales-history"
        element={
          <RequireAuth>
            <CustomerSalesHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/edit-member-profile"
        element={
          <RequireAuth>
            <EditMemberProfile />
          </RequireAuth>
        }
      />
      <Route
        path="/member-units-transaction-history"
        element={
          <RequireAuth>
            <MemberUnitsTransactionHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-agent"
        element={
          <RequireAuth>
            <ManageAgent />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-retailer"
        element={
          <RequireAuth>
            <ManageRetailerShop />
          </RequireAuth>
        }
      />
      <Route
        path="/agent-details"
        element={
          <RequireAuth>
            <AgentDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/retailer-shop-details"
        element={
          <RequireAuth>
            <RetailShopDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/agent-wallet-details"
        element={
          <RequireAuth>
            <AgentWalletPage />
          </RequireAuth>
        }
      />
      <Route
        path="/agent-cash-request-history"
        element={
          <RequireAuth>
            <AgentCashRequestHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/retail-cash-request-history"
        element={
          <RequireAuth>
            <RetailCashRequestHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/edit-agent-profile"
        element={
          <RequireAuth>
            <EditAgentProfile />
          </RequireAuth>
        }
      />
      <Route
        path="/edit-retail-profile"
        element={
          <RequireAuth>
            <EditRetailerProfile />
          </RequireAuth>
        }
      />
      <Route
        path="/create-agent-account"
        element={
          <RequireAuth>
            <CreateAgentAccount />
          </RequireAuth>
        }
      />
      <Route
        path="/create-retail-account"
        element={
          <RequireAuth>
            <CreateRetailerAccount />
          </RequireAuth>
        }
      />
      <Route
        path="/retail-wallet-details"
        element={
          <RequireAuth>
            <RetailerWalletPage />
          </RequireAuth>
        }
      />
      <Route
        path="/agent-units-transaction-history"
        element={
          <RequireAuth>
            <AgentUnitsTransactionHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/retail-units-transaction-history"
        element={
          <RequireAuth>
            <RetailerUnitsTransactionHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-advertising-agent"
        element={
          <RequireAuth>
            <ManageAdvertisingAgent />
          </RequireAuth>
        }
      />
      <Route
        path="/advertising-agent-approved-history"
        element={
          <RequireAuth>
            <AdvertisingAgentApprovedHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/advertising-agent-rejected-history"
        element={
          <RequireAuth>
            <AdvertisingAgentRejectedHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/advertising-agent-details"
        element={
          <RequireAuth>
            <AdvertisingAgentDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/advertising-agent-wallet-details"
        element={
          <RequireAuth>
            <AdvertisingAgentWallet />
          </RequireAuth>
        }
      />
      <Route
        path="/advertising-agent-invitation-details"
        element={
          <RequireAuth>
            <InvitationHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/advertising-agent-transaction"
        element={
          <RequireAuth>
            <AdvertisingAgentTransaction />
          </RequireAuth>
        }
      />
      <Route
        path="/advertising-agent-request-history"
        element={
          <RequireAuth>
            <RequestDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/advertising-agent-transaction-history"
        element={
          <RequireAuth>
            <AdvertisingAgentTransactionHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/advertising-agent-edit"
        element={
          <RequireAuth>
            <AdvertisingAgentEdit />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-business-agent"
        element={
          <RequireAuth>
            <ManageBusinessAgent />
          </RequireAuth>
        }
      />
      <Route
        path="/business-agent-details"
        element={
          <RequireAuth>
            <BusinessAgentDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/business-agent-wallet-details"
        element={
          <RequireAuth>
            <BusinessAgentWallet />
          </RequireAuth>
        }
      />
      <Route
        path="/business-agent-invitation-details"
        element={
          <RequireAuth>
            <BusinessAgentInvitationHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/business-agent-request-history"
        element={
          <RequireAuth>
            <BusinessAgentRequestDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/business-agent-transaction-history"
        element={
          <RequireAuth>
            <BusinessAgentTransactionHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/business-agent-edit"
        element={
          <RequireAuth>
            <BusinessAgentEdit />
          </RequireAuth>
        }
      />
      <Route
        path="/business-agent-transaction"
        element={
          <RequireAuth>
            <BusinessAgentTransaction />
          </RequireAuth>
        }
      />
      <Route
        path="/business-agent-approved-history"
        element={
          <RequireAuth>
            <BusinessAgentApprovedHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/business-agent-rejected-history"
        element={
          <RequireAuth>
            <BusinessAgentRejectedHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/agent-invite-history"
        element={
          <RequireAuth>
            <AgentInvitationHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/agent-promotion"
        element={
          <RequireAuth>
            <AgentRequestDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-supplier"
        element={
          <RequireAuth>
            <ManageSuppliers />
          </RequireAuth>
        }
      />
      <Route
        path="/create-supplier-account"
        element={
          <RequireAuth>
            <CreateSupplierAccount />
          </RequireAuth>
        }
      />
      <Route
        path="/supplier-details"
        element={
          <RequireAuth>
            <SupplierDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/supplier-wallet"
        element={
          <RequireAuth>
            <SupplierWallet />
          </RequireAuth>
        }
      />
      <Route
        path="/edit-supplier-profile"
        element={
          <RequireAuth>
            <EditSupplierProfile />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-category"
        element={
          <RequireAuth>
            <ManageCategory />
          </RequireAuth>
        }
      />
      <Route
        path="/category-details/:id"
        element={
          <RequireAuth>
            <CategoryDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-subcategory"
        element={
          <RequireAuth>
            <ManageSubCategories />
          </RequireAuth>
        }
      />
      <Route
        path="/subcategory-details/:id"
        element={
          <RequireAuth>
            <SubCategoryDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/create-category"
        element={
          <RequireAuth>
            <CreateCategory />
          </RequireAuth>
        }
      />
      <Route
        path="/create-subcategory"
        element={
          <RequireAuth>
            <CreateSubCategory />
          </RequireAuth>
        }
      />
      <Route
        path="/category-edit/:id"
        element={
          <RequireAuth>
            <EditCategory />
          </RequireAuth>
        }
      />
      <Route
        path="/subcategory-edit/:id"
        element={
          <RequireAuth>
            <EditSubCategory />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-product"
        element={
          <RequireAuth>
            <ManageProduct />
          </RequireAuth>
        }
      />
      <Route
        path="/create-product"
        element={
          <RequireAuth>
            <CreateProduct />
          </RequireAuth>
        }
      />
      <Route
        path="/product-details"
        element={
          <RequireAuth>
            <ProductDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/product-edit"
        element={
          <RequireAuth>
            <EditProduct />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-promotion"
        element={
          <RequireAuth>
            <ManagePromotion />
          </RequireAuth>
        }
      />
      <Route
        path="/promotion-details"
        element={
          <RequireAuth>
            <PromotionDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/create-promotion"
        element={
          <RequireAuth>
            <CreatePromotion />
          </RequireAuth>
        }
      />
      <Route
        path="/manage-parental-consent"
        element={
          <RequireAuth>
            <ManageParentsConsent />
          </RequireAuth>
        }
      />
      <Route
        path="/parental-consent-details"
        element={
          <RequireAuth>
            <ParentsConsentDetails />
          </RequireAuth>
        }
      />
      <Route
        path="/edit-parental-consent"
        element={
          <RequireAuth>
            <EditParentsConsent />
          </RequireAuth>
        }
      />
      <Route
        path="/edit-promotion"
        element={
          <RequireAuth>
            <EditPromotion />
          </RequireAuth>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
